
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexCEBwq82Iz7KuBTytwzI8g66Y6WgHNrrjZpl_KuNH8csMeta } from "C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/index.vue?macro=true";
import { default as loginxONXqcOqVwg_45uzLIPcXncIyegj9pJ3ScV3SksBHinf0Meta } from "C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/login.vue?macro=true";
import { default as registerNrzJ4syD4M3td29DK6G_45beVAJj_45_45tml1Nc9pQb8S5cgMeta } from "C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/register.vue?macro=true";
import { default as indexxwzw8V1xaINoypy9bphsoysWJq_45DmcgxjTK_M5sxkIQMeta } from "C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/app/index.vue?macro=true";
import { default as reset_45passwordMZ4VwWV3sZcvm_jIyw0HyybTS7GIEGlsLDlvnIEVvvsMeta } from "C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/reset-password.vue?macro=true";
import { default as generations_DPmjZQUQvrwqO7AeV8VDSAhgSww02Fk7k88g71kOXIMeta } from "C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/app/generations.vue?macro=true";
import { default as forgot_45passwordHVMOTxXSSmOyM53PM7WpZKOWeNzDBrWkCcycSYZKUn4Meta } from "C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/forgot-password.vue?macro=true";
import { default as email_45verificationUnVhHK2IpXt1ViuvkAUZmLB1D_xpWd4li2InDXeuXnsMeta } from "C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/email-verification.vue?macro=true";
import { default as _91id_93L2NBWcaZwL13QSVaPTCEr8c6iIvux9LExl7xPkIdrWwMeta } from "C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/app/generation/[id].vue?macro=true";
import { default as _91id_93_45animatedcvydfURs7_SABGw_aQtgE4Y9xHtOWK4FdOwEXSkh6NgMeta } from "C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/app/generation/[id]-animated.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexCEBwq82Iz7KuBTytwzI8g66Y6WgHNrrjZpl_KuNH8csMeta || {},
    component: () => import("C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/login.vue")
  },
  {
    name: "register",
    path: "/register",
    component: () => import("C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/register.vue")
  },
  {
    name: "app",
    path: "/app",
    meta: indexxwzw8V1xaINoypy9bphsoysWJq_45DmcgxjTK_M5sxkIQMeta || {},
    component: () => import("C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/app/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/reset-password.vue")
  },
  {
    name: "app-generations",
    path: "/app/generations",
    meta: generations_DPmjZQUQvrwqO7AeV8VDSAhgSww02Fk7k88g71kOXIMeta || {},
    component: () => import("C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/app/generations.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/forgot-password.vue")
  },
  {
    name: "email-verification",
    path: "/email-verification",
    component: () => import("C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/email-verification.vue")
  },
  {
    name: "app-generation-id",
    path: "/app/generation/:id()",
    meta: _91id_93L2NBWcaZwL13QSVaPTCEr8c6iIvux9LExl7xPkIdrWwMeta || {},
    component: () => import("C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/app/generation/[id].vue")
  },
  {
    name: "app-generation-id-animated",
    path: "/app/generation/:id()-animated",
    meta: _91id_93_45animatedcvydfURs7_SABGw_aQtgE4Y9xHtOWK4FdOwEXSkh6NgMeta || {},
    component: () => import("C:/Users/main8/Desktop/ploppin/ploppin-nuxt/pages/app/generation/[id]-animated.vue")
  }
]